import { logEvent } from "firebase/analytics"
import mixpanel, { Dict, RequestOptions } from "mixpanel-browser"
import { AnalyticsEvents } from "../../types/Analytics"
import { isExcludedEmail } from "../../utils/email"
import { isProduction } from "../../utils/general"
import { analytics } from "../App"
import { useAppContext } from "../Context"

export const useMixpanel = () => {
  const { user } = useAppContext()

  const logAnalyticsEvent = (
    eventName: AnalyticsEvents,
    eventProperties?: Dict,
    requestOptions?: RequestOptions,
  ) => {
    if (isProduction && !isExcludedEmail(user?.email || "")) {
      mixpanel.track(eventName, eventProperties, requestOptions)
      logEvent(analytics, eventName, eventProperties)
    }
  }

  return { logAnalyticsEvent }
}
